import PurchaseModal from '@/components/PurchaseModal/src/main'

export default {
  install(Vue, options) {
    Vue.prototype.$purchaseModal = (params) => {
      PurchaseModal(options, params)
    }
  }
}